module.exports = __webpack_public_path__ + "img/ads7.d3ee4ffd.png";